import ServiceImg1 from '../assets/img/carousel/5.jpg';
import ServiceImg2 from '../assets/img/carousel/3.jpg';
import Banner2 from '../assets/img/banner/banner_2.jpg';
import TGOrganicsImg from '../assets/img/projects/tg_organics.png';

export interface Project {
  id: string;
  title: string;
  description: string;
  image?: string;
  gradient?: string;
  imageType?: 'cover' | 'contain';
  link?: string;
  tag?: string;
  category: string;
}

export const PROJECTS: Project[] = [
  {
    id: 'education',
    title: 'Educational Solutions',
    description: 'Innovative platforms for schools and universities to manage students, curriculum, and online learning.',
    image: ServiceImg1,
    category: 'Education'
  },
  {
    id: 'payroll',
    title: 'Payroll Solutions',
    description: 'Comprehensive payroll management systems designed for accuracy, compliance, and ease of use.',
    image: ServiceImg2,
    category: 'Finance'
  },
  {
    id: 'manufacturing',
    title: 'Manufacturing ERP',
    description: 'Streamline your production, inventory, and supply chain with our robust ERP solutions.',
    image: Banner2,
    category: 'Industrial'
  },
  {
    id: 'kapas-kissan',
    title: 'Kapas Kissan (CCI)',
    description: 'Official Cotton Corporation of India app for paddy and cotton procurement management across India.',
    gradient: 'var(--gradient-1)',
    image: "https://play-lh.googleusercontent.com/jy-Y8ahSMoPb7-lo5OAtVlqp0ENQdw1DfsHlXRbt-Y_6VHxIPZvU4y8ljcr11b3VwfTgVOh1fuhO1TjLSmQvoJM=w240-h480-rw",
    imageType: 'contain',
    link: 'https://play.google.com/store/apps/details?id=com.cotcorp.kapaskisan',
    tag: 'Mobility Solution',
    category: 'Agriculture'
  },
  {
    id: 'fertilizer',
    title: 'Fertilizer & Urea Tracking',
    description: 'Innovative solution for monitoring fertilizer distribution and stock management for agricultural transparency.',
    gradient: 'var(--gradient-3)',
    image: "https://play-lh.googleusercontent.com/H0fHSO3Ato1zrHlC8iWTEfQ6mjQ_FLcFsMMB3uKlrgS4OdmzHIaHxWhz-LwJ35R--7zIjVk3vYhJoVH1_hVCp3U=w240-h480-rw",
    imageType: 'contain',
    link: 'https://play.google.com/store/apps/details?id=com.org.agri.urea',
    tag: 'Mobility Solution',
    category: 'Agriculture'
  },
  {
    id: 'tg-organics',
    title: 'TGOrganics App',
    description: 'A comprehensive platform for organic product certification, tracking, and marketplace for sustainable farming.',
    image: "https://res.cloudinary.com/dpotu9my7/image/upload/v1772891539/Logo_xshlok.png",
    imageType: 'contain',
    gradient: 'var(--gradient-4)',
    tag: 'Mobility Solution',
    category: 'Agriculture'
  },
  {
    id: 'hms',
    title: 'Hospital Management System',
    description: 'A complete enterprise solution for hospitals featuring patient records, pharmacy management, and OPD scheduling.',
    gradient: 'var(--gradient-2)',
    tag: 'Enterprise ERP',
    category: 'Healthcare'
  }
];
